<template>
  <v-card class="pa-3">
    <div>
      <v-row class="ma-0">
        <v-col
          xl="4"
          cols="3"
          lg="4"
          class="d-flex justify-center pt-2"
        >
          <img
            class="custom-position"
            :src="image_url"
          >
        </v-col>
        <v-col
          class="py-2 px-0"
          xl="7"
          lg="7"
          cols="8"
        >
          <v-skeleton-loader
            v-if="loading"
            class="mt-n4"
            type="list-item-three-line"
          />
          <div v-else class="headline wrap-word font-weight-bold fill-height">
            {{ contactInfo.first_name | upperCaseFirst }} {{ contactInfo.last_name | upperCaseFirst }}
            <br>
            <a
              class="subtitle-2 word-break text-ellipsis"
              :href="'mailto:' + contactInfo.email"
            >
              {{ contactInfo.email }}
            </a>
            <span class="subtitle-2">
              {{ contactInfo.phone }}
            </span>
          </div>
        </v-col>
        <v-col
          class="d-flex justify-end pa-0"
          cols="1"
        >
          <v-menu
            v-if="
              ($can('update','contacts') || $can('delete','contacts')) &&
              (contactInfo.email && !contactInfo.email.includes('pseudonymize.email'))
            "
            attach
            dense
            offset-y
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="grey"
                class="text--darken-2"
                v-track="'contact-action-menu'"
                icon
                @click.stop
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-if="$can('update','contacts')"
                v-track="'edit-contact-click'"
                dense
                @click="openEdit"
              >
                <v-icon class="mr-3 title">
                  mdi-pencil
                </v-icon>
                <v-list-item-title
                  class="font-weight-regular"
                >
                  Edit Contact
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="$can('delete','contacts')"
                v-track="'delete-contact-click'"
                dense
                @click="showDeletePrompt=true"
              >
                <v-icon class="title mr-3">
                  mdi-delete
                </v-icon><v-list-item-title class="font-weight-regular">
                  Delete Contact
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
        <v-skeleton-loader
          v-if="loading"
          type="table-heading@3"
        />
        <div v-else>
        <v-row v-if="contactInfo.company" class="ma-0">
          <v-col cols="4" class="py-2 px-0 body-2 grey--text">
            Company
          </v-col>
          <v-col cols="8" class="py-2 px-0">
            {{ contactInfo.company | upperCaseFirst }}
          </v-col>
        </v-row>
        <v-row v-if="formattedAddress !== ' '" class="ma-0">
          <v-col cols="4" class="py-2 px-0 body-2 grey--text">
            ADDRESS
          </v-col>
          <v-col cols="8" class="py-2 px-0">
          {{ formattedAddress }}
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="4" class="py-2 px-0 body-2 grey--text">
            CUSTOMER CREATED
          </v-col>
          <v-col cols="8" class="py-2 px-0">
            {{ contactInfo.created_at | formatDate }}
          </v-col>
        </v-row>
      </div>
    </div>
     <!-- delete contact dialog -->
     <v-dialog v-model="showDeletePrompt" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-medium-custom">
          <span class="secondary--font text-capitalize"> Delete Contact </span>
        </v-card-title>
        <v-card-text class="body-2">
          <p>
            You have selected this Contact to be deleted.
            Do you wish to continue deleting this Contact?
          </p>

          <b class="pt-10"> Warning: You cannot undo this action. </b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showDeletePrompt = false" 
            class="font-weight-bold"
            v-track="'cancel-delete-contact'"
           >
            Cancel
          </v-btn>
          <v-btn dark @click="confirmDelete()" class="font-weight-bold"
            v-track="'confirm-delete-contact'">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import { $serviceContacts } from "@core/services"
export default {
  name: 'service-contact-info',
  props: {
    contactInfo: {
      type: Object,
    },
    contactId: [String, Number],
    loading: Boolean
  },
  data () {
    return {
      showDeletePrompt: false,
    }
  },
  computed: {
    image_url(){
      return require(`../../../assets/images/avatar/${this.contactId%10}.png`)
    },
    formattedAddress() {
      const address = [
        this.contactInfo.address,
        this.contactInfo.city,
        this.contactInfo.state,
        this.contactInfo.country,
        
      ]
      return `${address.filter((attribute) => { return !!attribute }).join(', ') } ${this.contactInfo.postcode}`
    }
  },
  methods: {
    openEdit () {
      this.$router.push({ name: 'edit-contact', params: { id: this.contactInfo.id } })
    },
    /** On click of delete button confirmDelete() function */
    confirmDelete() {
      this.deleteContact(this.contactInfo)
      this.showDeletePrompt = false
    },

    /* eslint-disable */
    /** delete contact method */
    async deleteContact(data) {
      try {
        const response = await $serviceContacts.delete(data.id, {});
        if (response.data) {
          this.$store.dispatch("ui/snackbar", [
            {
              title: "Delete Contact",
              message: "Contact has been deleted.",
              type: "success",
            },
          ]);
          this.$router.push({ name: 'contact-list' })
        }
      } catch (error) {
        console.log("error===", error)
      }
    },
    checkPseudonymized (item) {
      if (item.email) {
        !item.email.includes('pseudonymize.email')
      }
      return false
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-position {
  max-width: 62px !important;
  max-height: 62px !important;
  height: 100%;
  border-radius: 50%;
  width: 100%;
}
.v-btn[on-hover-show] {
  display: none !important;
  position: absolute !important;
  top: 3%;
  right: 5%;
}
.v-card:hover .v-btn[on-hover-show] {
  display: flex !important;
}
</style>
